class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.targetButton = document.getElementById(this.dataset.targetButton);

    if (!this.targetButton) {
      this.hidden = true;
      return;
    }

    this.targetPriceContainer = document.getElementById(this.dataset.targetPrice);
    this.ownButton = this.querySelector('.sticky-add-to-cart__button');
    this.ownPriceContainer = this.querySelector('.sticky-add-to-cart__price');

    document.body.classList.add('has-sticky-add-to-cart');

    this.ownButton.addEventListener('click', () => {
      if (!this.targetButton.disabled) this.targetButton.click();
    });

    this.syncDisabledState();
    new MutationObserver(this.syncDisabledState.bind(this)).observe(this.targetButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    if (this.targetPriceContainer && this.ownPriceContainer) {
      new MutationObserver(this.syncPrice.bind(this)).observe(this.targetPriceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
      this.observer.observe(this.targetButton);
    }
  }

  syncDisabledState() {
    this.ownButton.disabled = this.targetButton.disabled;
  }

  syncPrice() {
    this.ownPriceContainer.innerHTML = this.targetPriceContainer.innerHTML;
  }

  onIntersect(entries) {
    var entry = entries[0];
    var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    this.classList.toggle('is-visible', scrolledPast);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
